import { cloneDeep } from 'lodash';
import PropTypes from 'prop-types';
import { Fragment, PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import LazyLoading from '../../components/LazyLoading';
import { jsonLdFaq } from '../../helpers';
import { ASSETS_PATH, COMPANY_ASSETS_PATH } from '../../helpers/constants';
import { setFunnelStepAction } from '../App/actions';
import { STEP_NONE, TITLE_SUFFIX } from '../App/constants';
import {
  getSuggestionsAction,
  setCityAction,
} from '../TravelSearchBar/actions';
import routesJson from './assets/json/routes.json';
import { CompanyView } from './View';

export class Company extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: null,
      searchHeaderBackground: null,
      siblings: [],
      destinationCards: [],
    };
    this.routes = routesJson;
    this.props.setFunnelStep(STEP_NONE);

    if (!Object.keys(this.routes).includes(props.location.pathname)) {
      this.state.loading = false;
    } else {
      import(`./assets/json/${this.routes[props.location.pathname]}`).then(
        (companyData) => {
          this.setState(() => ({
            data: companyData,
            loading: false,
          }));

          this.setState(() => ({
            searchHeaderBackground: `${ASSETS_PATH}/${companyData.searchHeader.backgroundImage}`,
          }));

          this.setState(() => ({
            companyHistoryLogo: `${COMPANY_ASSETS_PATH}/${companyData.history.image}`,
          }));

          companyData.destinationCards.forEach((destination) => {
            this.setState((prevState) => {
              const card = cloneDeep(destination);
              card.destinationCard.image = `${COMPANY_ASSETS_PATH}/${destination.destinationCard.image}`;
              return {
                destinationCards: [...prevState.destinationCards, card],
              };
            });
          });

          companyData.siblings.forEach((sibling) => {
            this.setState((prevState) => {
              const newSibling = cloneDeep(sibling);
              newSibling.logo = `${COMPANY_ASSETS_PATH}/${sibling.logo}`;
              return {
                siblings: [...prevState.siblings, newSibling],
              };
            });
          });
        },
      );
    }
  }

  componentDidMount() {
    if (!this.state.loading) {
      window.prerenderReady = true;
    }
  }

  render() {
    if (this.state.loading) {
      return <LazyLoading />;
    }

    if (!this.state.loading && !this.state.data) {
      return <Redirect to="" />;
    }

    return (
      <Fragment>
        <Helmet>
          <title>{this.state.data.metaTitle}</title>
          <meta content={this.state.data.metaDescription} name="description" />
          <meta content="website" property="og:type" />
          <meta
            content={document.location.origin + this.state.data.path}
            property="og:url"
          />
          <meta
            content={this.state.data.metaTitle + TITLE_SUFFIX}
            property="og:title"
          />
          <meta
            content={this.state.data.metaDescription}
            property="og:description"
          />
          <meta
            content={`${ASSETS_PATH}/${this.state.data.metaImage}`}
            property="og:image"
          />
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              url: this.state.data.path,
              name: this.state.data.metaTitle,
              description: this.state.data.metaDescription,
            })}
          </script>
          {this.state.data.faqs.length > 0 && (
            <script type="application/ld+json">
              {jsonLdFaq(this.state.data.faqs)}
            </script>
          )}
        </Helmet>
        <CompanyView
          companyHistoryLogo={this.state.companyHistoryLogo}
          data={this.state.data}
          destinationCards={this.state.destinationCards}
          getCitySuggestions={this.props.getSuggestions}
          searchHeaderBackground={this.state.searchHeaderBackground}
          setDestinationCity={this.props.setCity}
          siblings={this.state.siblings}
        />
      </Fragment>
    );
  }
}

Company.propTypes = {
  getSuggestions: PropTypes.func,
  location: PropTypes.object,
  setCity: PropTypes.func,
  setFunnelStep: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({});

export function mapDispatchToProps(dispatch) {
  return {
    setFunnelStep: (step) => dispatch(setFunnelStepAction(step)),
    getSuggestions: (direction, query) =>
      dispatch(getSuggestionsAction(direction, query)),
    setCity: (cityName, cityId, direction) =>
      dispatch(setCityAction(cityName, cityId, direction)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Company);
